export default __webpack_public_path__ + "static/media/celular-suvinil.d5ca2107.png";